<div (click)="$event.stopPropagation()" class="dynamic-notification-wrapper">
    <div *ngIf="mouseOver" class="flex flex-row items-start">
        <div class="flex items-center justify-center">
            <button *ngIf="!read"
                    [matTooltip]="'Mark as read'" 
                    matTooltipPosition="below"
                    matTooltipShowDelay="500"
                    (click)="handleRead($event)"
                    class="flex items-center mr-4 lendio-density-2">
                <mat-icon fontSet="material-icons-outlined">drafts</mat-icon>
            </button>
            <button *ngIf="read"
                    [matTooltip]="'Mark as unread'" 
                    matTooltipPosition="below"
                    matTooltipShowDelay="500"
                    (click)="handleUnread($event)"
                    class="flex items-center lendio-density-2">
                <mat-icon fontSet="material-icons-outlined" class="mr-3">mark_email_unread</mat-icon>
            </button>
            <button (click)="handleDelete($event)" 
                    class="flex items-center justify-center lendio-density-2">
                <mat-icon [matTooltip]="'Clear'" 
                        matTooltipPosition="below"
                        matTooltipShowDelay="500"
                        fontSet="material-symbols-outlined">
                        delete
                </mat-icon>
            </button>
        </div>
    </div>
</div>
